import { Injectable, inject } from '@angular/core'
import { RestClientPaged } from '@elderbyte/ngx-starter'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { environment } from '../../../environments/environment'

export enum PackageMigrationCommandType {
  RE_EMIT = 'RE_EMIT',
}

export interface PackageMigrationCommand {
  type: PackageMigrationCommandType
  packageIds: string[]
}

@Injectable({
  providedIn: 'root',
})
export class PackageMigrationService extends RestClientPaged<any, string> {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const http = inject(HttpClient)

    super(environment.apiPath + '/migration/package', http, {
      idField: 'id',
    })
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public migrate(body: PackageMigrationCommand): Observable<unknown> {
    return this.http.post<any>(this.restEndpoint, body)
  }
}
